var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.942 19.229a.794.794 0 01-.776.628H2.77a.794.794 0 110-1.589h1.134c.668 0 1.245-.467 1.383-1.12L8.232 3.297a1.414 1.414 0 00-1.383-1.708H4a1.277 1.277 0 00-1.247 1.005l-.54 2.49a1 1 0 01-1.957-.42L1.01 1.12A1.414 1.414 0 012.393 0h15.66c.9 0 1.57.829 1.384 1.708l-.717 3.375a.996.996 0 11-1.948-.419l.45-2.076a.824.824 0 00-.805-1h-3.5c-.667 0-1.244.468-1.383 1.12L8.53 16.84a1.182 1.182 0 001.156 1.428h.48c.505 0 .882.466.776.96z"
  })));
}
export default SvgText;